import {Card, Table} from 'antd';
import {ColumnProps} from 'antd/lib/table';
import {useAccountBalancesQuery} from 'api/generated';
import {TableCard} from 'components';
import {formatDate, formatIntAmount} from 'lib/formaters';
import React from 'react';
import {useParams} from 'react-router-dom';
import styled from 'styled-components';
import {SectionProps} from '../types';

const Amount = styled.span`
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
`;

export const AccountBalancesDetails: React.FC<SectionProps> = ({account, cardProps}) => {
  const {accountId} = useParams<{accountId: string}>();
  const {data, loading, previousData} = useAccountBalancesQuery({
    variables: {accountId}
  });

  if (!account) return <Card {...cardProps} title="Account balances" />;

  const payload = data ?? previousData;
  const balances = payload?.accountBalances.items || [];

  const columns: ColumnProps<any>[] = [
    {
      title: 'Currency',
      dataIndex: 'currency',
      key: 'currency',
      className: 'minimized-cell'
    },
    {
      title: 'Cleared Amount',
      dataIndex: 'clearedAmount',
      key: 'clearedAmount',
      align: 'right',
      render: (amount, record) => <Amount>{formatIntAmount(amount, record.currency)}</Amount>
    },
    {
      title: 'Outstanding Amount',
      dataIndex: 'outstandingAmount',
      key: 'outstandingAmount',
      align: 'right',
      render: (amount, record) => <Amount>{formatIntAmount(amount, record.currency)}</Amount>
    },
    {
      title: 'Total Amount',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      align: 'right',
      render: (amount, record) => <Amount>{formatIntAmount(amount, record.currency)}</Amount>
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      align: 'right',
      render: (date) => formatDate(date)
    }
  ];

  if (balances.length === 0) return null;

  return (
    <TableCard {...cardProps} title="Account balances">
      <Table
        rowKey="currency"
        dataSource={balances}
        columns={columns}
        loading={loading}
        pagination={false}
      />
    </TableCard>
  );
};
